// // This file can be replaced during build by using the `fileReplacements` array.
// // `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// // The list of file replacements can be found in `angular.json`.


// export const environment = {
//   production: false,
//   api_rul: 'http://localhost:8001/api',
//   auth_url: 'http://localhost:8001/auth',
//   // api_rul: 'http://test.trackpayout.com:8001/api',
//   // auth_url: 'http://test.trackpayout.com:8001/auth',
//   //file_url: 'http://test.trackpayout.com'


//   // api_rul: 'https://trackpayout-backend.contisofttechno.com/api',
//   // auth_url: 'https://trackpayout-backend.contisofttechno.com/auth',
//   file_url : 'https://trackpayout.contisofttechno.com',

//   // jwttoken: "jwttokenverificationsecretkey_this_is_required_everytime_you_generate_or_validate_token_for_trackpayout"
// };

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,

  // api_rul: 'http://192.168.1.58:8001/api',
  // auth_url: 'http://192.168.1.58:8001/auth',

  // api_rul: 'http://localhost:8001/api',
  // auth_url: 'http://localhost:8001/auth',
  // file_url: 'https://trackpayout.contisofttechno.com',


  // api_rul: 'http://test.trackpayout.com:8001/api',
  // auth_url: 'http://test.trackpayout.com:8001/auth',
  // file_url: 'http://test.trackpayout.com'

  api_rul: 'https://trackpayout-backend.contisofttechno.com/api',
  auth_url: 'https://trackpayout-backend.contisofttechno.com/auth',
  file_url: 'https://trackpayout.contisofttechno.com',


  // api_rul: 'https://trackpayout.contisofttechno.com:8017/api',
  // auth_url: 'https://trackpayout.contisofttechno.com:8017/auth',
  // file_url: 'https://trackpayout.contisofttechno.com',

  // jwttoken: "jwttokenverificationsecretkey_this_is_required_everytime_you_generate_or_validate_token_for_trackpayout"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';
// Included with Angular CLI.
